import {
    TActionStrategy,
    TSendTemplateDraft,
} from 'src/modules/assistant/actions/types';
import { buildLeadTemplateSend } from './buildLeadTemplateSend';

/**
 * Legacy areas: sends the template through LeadState (`/leads/whatsApp`).
 */
export const sendLegacyTemplate: TActionStrategy<TSendTemplateDraft> = async (
    draft,
    deps
) => {
    const payload = await buildLeadTemplateSend(draft, deps);
    if (!payload) return false;
    return deps.leadActions.sendTemplateV2(
        { ...payload, isAssistantGenerated: true },
        deps.lead._id
    );
};
